import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { TranslatePipe } from '@core/i18n-legacy';
import { HeaderThreadComponent, HrAssistantChatComponent } from '@core/intelligence-smart-ui';
import {
  ButtonComponent,
  DividerComponent,
  HeadingComponent,
  IconComponent,
} from '@core/user-interface-legacy';
import {
  canActivateDataSource,
  SimpleViewComponent,
  ViewsLocalStorageService,
} from '@core/views-legacy';
import { WrappedTableListGroupHeadingComponent } from '@core/views-ui';
import { dataSourceProviders, provideListLayout, provideViewBaseRoute } from '@core/views-util';
import { AskHrChatFeatureId } from '@tellent-ask-hr/core-types';

import { AskTicketBoardItemComponent } from '../../ask-tickets-view/ask-ticket-board-item/ask-ticket-board-item.component';
import { AskTicketsDataSourceService } from '../../ask-tickets-view/ask-tickets-data-source.service';

const DATASOURCE_ID = 'ask_tickets';

@Component({
  selector: 'tlc-chat-user-requests-view',
  template: `
    <tlc-chat-header-thread (back)="backToWelcome()" (close)="onClose()" />
    <div margin-lr-medium margin-top>
      <rt-heading variant="heading large">
        {{ 'tlc.ask_hr.requests.chat.open_requests' | translate }}
      </rt-heading>
    </div>
    @if (canActivate()) {
      <rt-simple-view
        viewId="ask_tickets:hr_assistant"
        [selfScrollEnabled]="true"
        [hasControls]="false"
        [autoSetHeight]="false"
        initialLayout="list"
        class="view"
      />
    }
    <rt-divider />
    <div class="footer">
      <rt-button variant="tertiary" (click)="goToCreateTicket()">
        <rt-icon name="send" />
        {{ 'tlc.ask_hr.requests.chat.create_another_ticket' | translate }}
      </rt-button>
      <rt-button variant="tertiary" (click)="backToWelcome()">
        <rt-icon name="message" />
        {{ 'tlc.ask_hr.requests.chat.start_conversation' | translate }}
      </rt-button>
    </div>
  `,
  imports: [
    SimpleViewComponent,
    HeaderThreadComponent,
    HeadingComponent,
    TranslatePipe,
    DividerComponent,
    IconComponent,
    ButtonComponent,
  ],
  providers: [
    ViewsLocalStorageService,
    provideViewBaseRoute('/asks/list'),
    AskTicketsDataSourceService,
    dataSourceProviders(DATASOURCE_ID, {
      [DATASOURCE_ID]: AskTicketsDataSourceService,
    }),
    provideListLayout({
      [DATASOURCE_ID]: {
        header: WrappedTableListGroupHeadingComponent,
        record: AskTicketBoardItemComponent,
        recordSettings: {
          hasPadding: false,
        },
      },
    }),
  ],
  styleUrls: ['./chat-user-tickets-view.component.less'],
})
export class ChatUserTicketsViewComponent {
  private readonly canActivateFn = canActivateDataSource();
  private readonly canActivate$ = this.canActivateFn();
  private readonly assistantChatComponent = inject(HrAssistantChatComponent);
  protected canActivate = toSignal(this.canActivate$);

  protected onClose() {
    this.assistantChatComponent.close.emit();
  }

  protected backToWelcome() {
    this.assistantChatComponent.clearFeature();
  }

  protected goToCreateTicket() {
    this.assistantChatComponent.setFeatureById(AskHrChatFeatureId.Forms);
  }
}
